import React from 'react'
import Validator from 'validatorjs'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import TextArea from 'components/TextArea'
import Input from 'components/Input'
import Button from 'components/Button'

import { CLAIM_UPDATES } from 'constants'

import { statusChanged } from 'components/RequestStatus/actions'
import { notificationFetched } from 'scenes/VehicleDetail/components/Claim/Notifications/actions'

import './styles.scss'

export class EditNotification extends BaseComponent {
  static validationRules = {
    title: 'string|required|min:2',
    content: 'string|required|min:5',
  }
  static validationRulesSMS = {
    title: 'string|required|min:2',
    content: 'string|required|min:5',
    sms_content: 'string|required|min:5',
  }

  constructor(props) {
    super(props)

    this.state = {
      buttonProps: {
        disabled: false
      },
      formData: {
        title: this.props.notification.title,
        content: this.props.notification.content,
        sms_content: ''
      }
    }

    this._bind('_handleSubmit', '_handleChange', '_validate', '_renderSMSField')
  }

  componentDidMount() {
    if (this.props.sms_enabled === true && this.state.formData.sms_content === ''){
      this.setState({
        buttonProps: {
          disabled: true
        }
      })
    }
  }

  _handleSubmit(e) {
    this.props.updateRequestStatus('progress', 'Creando notificación...')
    request(CLAIM_UPDATES(this.props.claimId), {
      method: 'POST',
      body: this.state.formData
    }).then((res) => {
      this.props.updateRequestStatus(res.status, res.message)
      this.props.notificationFetched([res.update, ...this.props.notification_list])
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos crear la notificación')
    })

    this.context.toggleModal(false)
  }

  _handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e.target.name, e.target.value)
  }

  _validate(name, value) {
    const formData = {
      ...this.state.formData,
      [name]: value
    }
    var rules = this.props.sms_enabled ? EditNotification.validationRulesSMS : EditNotification.validationRules
    const validator = new Validator(formData, rules)
    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      }
    })
  }

  _renderSMSField() {
    var title = "SMS   " + this.state.formData['sms_content'].length + " / 160"
    return (this.props.sms_enabled) ? (
      <span>
        <br></br>
        <Input  label={title}
          name="sms_content"
          placeholder="Texto SMS"
          value={this.state.formData.sms_content}
          onChange={this._handleChange} />
      </span>
    ): null
  }

  render() {
    return (
      <div id="EditNotification" className="EditNotification Modal__content">
        <div className="EditNotification__header d-flex justify-content-between align-items-center">
          <h1>Editar notificación</h1>
          <span className="material-icons close-button" onClick={() => this.context.toggleModal(false)}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex EditNotification__form">
          <p className="instructions">Al crear una actualización, todos los conductores serán notificados</p>
          <Input  label="Titulo"
                  name="title"
                  placeholder="Título de la notificación"
                  value={this.state.formData.title}
                  onChange={this._handleChange} />

          <TextArea placeholder="Ej: Tu coche ha salido del taller"
                    label="Mensaje:"
                    name="content"
                    value={this.state.formData.content}
                    onChange={this._handleChange} />

          {this._renderSMSField()}

          <div className="controls">
            <Button buttonType="primary" size="big" {...this.state.buttonProps}>Crear notificación</Button>
          </div>
        </form>
      </div>
    )
  }
}

EditNotification.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    notification_list: state.claimNotification.get('notification_list')
  }
}

const mapDispatchToProps = (dispatch) => {

  return {
    notificationFetched: (notification_list) => dispatch(notificationFetched(notification_list)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditNotification)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Suggested/EditNotification.js